export const inMemoryEventBus = ({ domainEventsRecorder }) => async (domainEvents) => domainEventsRecorder.record(domainEvents);
